var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { Popover, Box, IconButton } from '@mui/material';
import { Close, Info } from '@mui/icons-material';
export function HelperTextWithPopover(_a) {
    var label = _a.label, sx = _a.sx, children = _a.children, _b = _a.isCloseButtonVisible, isCloseButtonVisible = _b === void 0 ? false : _b, _c = _a.popoverMarginLeft, popoverMarginLeft = _c === void 0 ? 1 : _c;
    var iconButtonRef = useRef(null);
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var handlePopoverOpen = function () {
        if (iconButtonRef.current) {
            setAnchorEl(iconButtonRef.current);
        }
    };
    var handlePopoverClose = function () { return setAnchorEl(null); };
    var isPopoverOpen = !!anchorEl;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ sx: __assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5 }, sx) }, { children: [label, _jsx(IconButton, __assign({ ref: iconButtonRef, onClick: handlePopoverOpen, sx: { p: 0 }, "aria-label": "open popover" }, { children: _jsx(Info, { fontSize: "small" }) }))] })), _jsx(Popover, __assign({ id: isPopoverOpen ? 'popover' : undefined, open: isPopoverOpen, anchorEl: anchorEl, onClose: handlePopoverClose, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, slotProps: {
                    paper: {
                        sx: {
                            ml: popoverMarginLeft,
                        },
                    },
                } }, { children: _jsxs(_Fragment, { children: [children, isCloseButtonVisible && (_jsx(IconButton, __assign({ onClick: handlePopoverClose, "aria-label": "close popover", sx: { position: 'absolute', top: '2px', right: '2px' } }, { children: _jsx(Close, { fontSize: "small" }) })))] }) }))] }));
}
